import React, { Component, useEffect, useState, useId } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import store from "@/redux/store";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useTranslation } from "react-i18next";
import { useModel } from "@/models/base/useModel";

import { EyeIcon } from '@heroicons/react/24/outline';
import Drawer from "@/controllers/Drawer";
import { IntroPanel } from "../base/view/intro";
import {removeUser, cretaeOTPRequest} from "@/reducers/User";
import {showConfirmModal, hideModal} from "@/reducers/ModalPopup";



interface ComponentProps {
  [key: string]: any; //Accept any property
};
function Overview({...props}: ComponentProps): any{
    const [selectedData, setSelectedData] = useState(null);
    const navigate = useNavigate();
    const { t, i18n, ready } = useTranslation();
      const directory = null;
      const uuidKey = useId()
      
      const dispatch = useDispatch<any>();
      const [cdata, setData] = useState();
      type RootState = ReturnType<typeof store.getState>
      
      const { customers, error, redirect } = useSelector((state: RootState) => {
        return {
          customers: state.CustomerReducer.customers,
          error: state.CustomerReducer.error,
          redirect: state.CustomerReducer.redirect,
          
          
        };
      },shallowEqual);
      //    const {tm, registerField} = useModel('name', customerModel);
      console.debug(customers);

const showPreview = (event, item) => {
    event.preventDefault();

    setSelectedData({data: item, click: new Date()});

    return false;
  }
const removeHandler = (event, item) => {
    event.preventDefault();

    store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));

    return false;

    }

    async function setClipboard(text) {
      const type = "text/plain";
      const clipboardItemData = {
        [type]: text,
      };
      const clipboardItem = new ClipboardItem(clipboardItemData);
      await navigator.clipboard.write([clipboardItem]);
    }

    const otpRequestHandler = (event, item) => {
        store.dispatch(cretaeOTPRequest({key: item.key})).then( (data) => {
            
            let clipboardPromise = setClipboard(data.payload.data.response);
            clipboardPromise.then((item) => {
                alert("EENMALIG WACHTWOORD : "+data.payload.data.response+"\n\nDit wachtwoord is gekopieerd naar uw klemboard.\nMet CTRL+V kunt u het eenmalige wachtwoord kopiëren.");
            });
            

        });

        //store.dispatch(removeUser({type:props.type, key: item.key}));
        store.dispatch(hideModal(null));

        return false;

    }

const confirmedRemoveHandler = (props) => {
        store.dispatch(removeUser({type:props.type, key: props.item.key}));

    //store.dispatch(removeUser({type:props.type, key: item.key}));
    store.dispatch(hideModal(null));

    return false;
  }


  return (
    <>

    <div className="">

<div className="pb-5 sm:flex sm:items-top sm:justify-top">
        {props.type && props.type == 1 &&
        <>
        <IntroPanel txtKey="workers"/>
        </>
      }

        {props.type && props.type == 2 &&
          <IntroPanel txtKey="persons"/>
        }

      <div className="mt-3 sm:ml-4 sm:mt-0">
        <Link to={"add"}
          type="button"
          className="inline-flex items-top rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          {t("views.workers.buttons.toevoegen")}
        </Link>
      </div>
    </div>


      <div className="mt-2 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Naam
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Email
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Tel nr.
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Functie
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {props.data && props.data.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                        <div className="flex gap-x-6">
                            <EyeIcon className="hidden h-6 w-5 flex-none text-gray-400 sm:block cursor-pointer" onClick={(e) => {showPreview(e, item);}}/>

                      {item.first_name}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{ ((item?.userfields?.userobj) ?  (item?.userfields?.userobj)?.company_email : "") }</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item?.phone}</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item?.function}</td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                              <Link
                              to={null}
                              onClick={(e) => {otpRequestHandler(e, item);}}
                              className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 mr-5">
                      Eenmalig toegang aanmaken
                    </Link>
                                <Link
                                to={null}
                                onClick={(e) => {removeHandler(e, item);}}
                                className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 mr-5">
                        Ontkoppelen<span className="sr-only">, {item.name}</span>
                      </Link>
                    {item.pivot.type != 12 && item.pivot.state == 0 && item.noEdit == 0 &&
                    <>

                      <Link to={"edit/"+item.key} className="text-indigo-600 hover:text-indigo-900">
                        Edit<span className="sr-only">, {item.name}</span>
                      </Link>
                      </>
                      }
                      {item.pivot.state == 1 &&
                      <span className="inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                        Gekoppeld
                    </span>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

          <Drawer data={selectedData} type="user" key={ uuidKey }/>

    </>

  )


}

export {Overview}